import React from 'react';
import {
  MdHome,
  MdDirections,
  MdHourglassFull,
  MdLocalAtm,
  MdChevronRight,
} from 'react-icons/md';
import { standards } from '../../../../components';
import styles from './Choices.module.css';
import format from 'date-fns/format';
import ptBR from 'date-fns/locale/pt-BR'

function useChoices(commands) {
  
  const goToDeliveryMethod = () => commands.goToStep(1);
  const goToDateChoice = () => commands.goToStep(2);
  const goToAddress = () => commands.goToStep(4);
  const goToPayment = () => commands.goToStep(5);

  const shifts={
    morning:' pela manhã',
    afternoon:' a tarde',
    night:' a noite'
  };

  const payments={
    credit_card: 'Cartão de crédito',
    debit_card: 'Cartão de débito',
    billet: 'Boleto',
    cash: 'Dinheiro',
    bank_transfer: `Transferência bancária / Pix`,
  };

  return ({
    eventHandlers: {
      goToDeliveryMethod,
      goToPayment,
      goToDateChoice,
      goToAddress,
    },
    localStates: {
      shifts, payments
    },
  });
}

export default function Choices(props) {
  const { sharedStates, commands } = props;
  const { eventHandlers, localStates } = useChoices(commands);
  
  const {
    order: { deliveryMethod, deliveryAddr, deliveryDate, deliveryShift, paymentMethod },
    consumerSpaceData,
  } = sharedStates;

  const {
    street, number, neighborhood, complement, city, uf,
  } = deliveryAddr;

  const deliveryDateFormatted = format(deliveryDate, 'EEEE (dd/MM)', {locale: ptBR});

  return (
    <div className={styles.container}>
      <div className={styles.choiceBox}>
        <div className={styles.choice}>
          <MdHome size={35} color={standards.colors.neutral.strong} />
          <p className={styles.text}>{deliveryMethod === 'home_delivery' ? `Entrega ${consumerSpaceData ? 'na empresa' : 'em domicílio'}` : 'Retirada no local'}</p>
        </div>
        <MdChevronRight
          size={25}
          color={standards.colors.neutral.strong}
          onClick={eventHandlers.goToDeliveryMethod}
        />
      </div>
      <div className={styles.choiceBox}>
        <div className={styles.choice}>
          <MdDirections size={35} color={standards.colors.neutral.strong} />
          <p className={styles.text}>{`${`${street}, ${number} - ${neighborhood} ${complement ? `(${complement})` : ''}. ${city} - ${uf}`.substring(0,30)}...`}</p>
        </div>
        <MdChevronRight
          size={25}
          color={standards.colors.neutral.strong}
          onClick={eventHandlers.goToAddress}
        />
      </div>
      <div className={styles.choiceBox}>
        <div className={styles.choice}>
          <MdHourglassFull size={35} color={standards.colors.neutral.strong} />
          <p className={styles.text}>{`${deliveryDateFormatted[0].toUpperCase() + deliveryDateFormatted.slice(1)}${localStates.shifts[deliveryShift]}`}</p>
        </div>
        <MdChevronRight
          size={25}
          color={standards.colors.neutral.strong}
          onClick={eventHandlers.goToDateChoice}
        />
      </div>
      <div className={styles.choiceBox}>
        <div className={styles.choice}>
          <MdLocalAtm size={35} color={standards.colors.neutral.strong} />
          <p className={styles.text}>{localStates.payments[paymentMethod]}</p>
        </div>
        <MdChevronRight
          size={25}
          color={standards.colors.neutral.strong}
          onClick={eventHandlers.goToPayment}
        />
      </div>
    </div>
  );
}
